module.exports = __webpack_public_path__ + "static/media/age_2.efa5863d.svg";